import { Event } from "../events/Event";
import { EventDispatcher } from "../events/EventDispatcher";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { MeshQuadTexture } from "../webgl/utils/MeshQuadTexture";
export class Filter extends EventDispatcher {
    constructor() {
        super();
        this.left = 0;
        this.top = 0;
        this.width = 0;
        this.height = 0;
        let rect1 = this._rectMeshNormY = new MeshQuadTexture();
        rect1.addQuad([0, 0, 1, 0, 1, 1, 0, 1], [0, 0, 1, 0, 1, 1, 0, 1], 0xffffffff, true);
        this._rectMeshVBNormY = new Float32Array(rect1.vbBuffer);
        let rectInvY = this._rectMeshInvY = new MeshQuadTexture();
        rectInvY.addQuad([0, 0, 1, 0, 1, 1, 0, 1], [0, 1, 1, 1, 1, 0, 0, 0], 0xffffffff, true);
        this._rectMeshVBInvY = new Float32Array(rectInvY.vbBuffer);
        this.useFlipY(false);
    }
    onChange() {
        this.event(Event.CHANGED);
    }
    useFlipY(b) {
        this._rectMesh = b ? this._rectMeshInvY : this._rectMeshNormY;
        this._rectMeshVB = b ? this._rectMeshVBInvY : this._rectMeshVBNormY;
    }
    set render2D(r) {
        this._render2D = r;
    }
    get type() { return -1; }
}
Filter.COLOR = 0x20;
Filter._filter = function (sprite, context, x, y) {
    var next = this._next;
    if (!next)
        return;
    var filters = sprite.filters, len = filters.length;
    if (len == 1 && (filters[0].type == Filter.COLOR)) {
        context.save();
        context.setColorFilter(filters[0]);
        next._fun.call(next, sprite, context, x, y);
        context.restore();
        return;
    }
    let cache = sprite._getCacheStyle();
    let rtOffX = 0, rtOffY = 0;
    if (this._renderNextToCacheRT(sprite, context, 16, 16, 16, 16)) {
        rtOffX = cache.cacheRect.x;
        rtOffY = cache.cacheRect.y;
        let src = cache.renderTexture;
        let dst = src;
        let width = src.width;
        let height = src.height;
        for (let i = 0; i < len; i++) {
            src = dst;
            var filter = filters[i];
            filter._render2D = context.render2D;
            filter.useFlipY(i != 0);
            filter.render(src, width, height);
            width = filter.width;
            height = filter.height;
            dst = filter.texture;
            rtOffX += filter.left;
            rtOffY += filter.top;
        }
        cache.renderTexture = dst;
        cache.renderTexOffx = rtOffX;
        cache.renderTexOffy = rtOffY;
    }
    cache.renderTexture && context._drawRenderTexture(cache.renderTexture, x + cache.renderTexOffx, y + cache.renderTexOffy, cache.renderTexture.width, cache.renderTexture.height, null, 1.0, RenderTexture2D.defuv);
};
